module.exports = __webpack_public_path__ + "img/package.0d6fdc27.svg";